// JavaScript Document
import GraphQL from './ConsultaGraphQLColaboradores';

import url from './ApiUrl.js';

function handleError(err){
	console.log(`Request failed: ${err}`);
}

const fetchUsers = (This) => {

	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL()),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {

		This.props.dispatch({
			type: 'FETCH_COLABORADORES',
			payload: {
				dataColaboradores: res.data.appInfo.colaboradores
			}
		})

	})
	.catch(err => handleError(err));

	//termina fetch
}

export default fetchUsers;
